// import { EmployeeList } from "components/Employee";

import { AuthenticatedLayout } from "../../layouts";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { EmployeeList } from "../../components/EmployeeList";
import { FC } from "react";
import { PayrollFederalEarningList } from "../../components/PayrollFederalEarningList/PayrollFederalEarningList";

export interface IPayrollFederalEarningsListPage {}

export const PayrollFederalEarningsListPage: FC<IPayrollFederalEarningsListPage> = (
  props: IPayrollFederalEarningsListPage
) => {
  return (
    <AuthenticatedLayout
      pageTitle="Payroll Federal Earning"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "", navigateTo: "/payroll-federal-earning/list" },
      ]}
      mainContents={<PayrollFederalEarningList />}
    />
  );
};
